import { Banknote, Menu, ChevronRight } from "lucide-react";

// Header Component
export const Header = ({ currentUser, onMenuClick, cashTotals, onCashClick }) => (
  <>
    <div className="bg-gradient-to-b from-slate-900/95 to-slate-800/95 backdrop-blur-xl border-b border-white/10 sticky top-0 z-40 shadow-2xl">
      <div className="flex items-center justify-between p-4 sm:p-5">
        {/* Logo and User Info */}
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl flex items-center justify-center border-2 border-orange-400/40 shadow-xl bg-gradient-to-br from-white to-gray-50 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-orange-400/10 to-transparent"></div>
            <img src="/logo.png" alt="Logo VGL" className="w-8 h-8 sm:w-10 sm:h-10 object-contain relative z-10" />
          </div>
          <div>
            <h1 className="text-white font-bold text-lg sm:text-xl tracking-tight">VGL TRANS EXPRESS</h1>
            <div className="flex items-center space-x-2 mt-0.5">
              <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse shadow-lg shadow-green-400/50"></div>
              <p className="text-gray-300 text-sm font-medium">{currentUser?.name || 'Șofer'}</p>
            </div>
          </div>
        </div>

        {/* Menu Button */}
        <button
          onClick={onMenuClick}
          className="w-11 h-11 bg-gradient-to-br from-white/15 to-white/5 hover:from-white/25 hover:to-white/10 rounded-xl flex items-center justify-center text-white transition-all active:scale-95 border border-white/10 shadow-lg"
        >
          <Menu className="w-5 h-5" />
        </button>
      </div>

      {/* Cash Banner */}
      {cashTotals.pending > 0 && (
        <div className="relative overflow-hidden">
          {/* Animated background gradient */}
          <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 via-emerald-500/20 to-green-500/20 animate-pulse"></div>
          
          <div className="relative border-t border-green-500/30 backdrop-blur-sm">
            <div className="p-4 sm:p-5">
              <div className="flex items-center justify-between gap-3">
                {/* Left side - Icon and Text */}
                <div className="flex items-center space-x-3 flex-1 min-w-0">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-500/30 rounded-xl flex items-center justify-center flex-shrink-0 border border-green-500/40 shadow-lg">
                    <Banknote className="w-5 h-5 sm:w-6 sm:h-6 text-green-300" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="text-green-200 font-medium text-sm block mb-1">Cash de încasat</span>
                    <span className="text-green-300 font-bold text-xl sm:text-2xl block truncate">
                      {cashTotals.pending.toLocaleString('ro-RO')} RON
                    </span>
                  </div>
                </div>

                {/* Right side - Button */}
                <button
                  onClick={onCashClick}
                  className="bg-gradient-to-r from-green-500/30 to-emerald-500/30 hover:from-green-500/40 hover:to-emerald-500/40 text-green-200 border border-green-500/40 rounded-xl py-3 px-4 sm:px-5 font-semibold transition-all active:scale-95 flex items-center space-x-2 shadow-lg flex-shrink-0"
                >
                  <span className="hidden sm:inline">Gestionează</span>
                  <span className="sm:hidden">Detalii</span>
                  <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  </>
);